import { render, staticRenderFns } from "./ConfirmDeleteAuth0AccountModal.vue?vue&type=template&id=2115f06c&scoped=true"
import script from "./ConfirmDeleteAuth0AccountModal.vue?vue&type=script&lang=js"
export * from "./ConfirmDeleteAuth0AccountModal.vue?vue&type=script&lang=js"
import style0 from "./ConfirmDeleteAuth0AccountModal.vue?vue&type=style&index=0&id=2115f06c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2115f06c",
  null
  
)

export default component.exports